import { IconButton, IconButtonProps, useColorModeValue } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import React from 'react';

interface IMenuToggleProps extends IconButtonProps {
    isOpen: boolean;
    onToggle: () => void;
}

export const MenuToggle = React.forwardRef<HTMLButtonElement, IMenuToggleProps>(({ isOpen, onToggle, ...rest }, ref) => (
    <motion.div initial={false} animate={isOpen ? 'open' : 'closed'}>
        <IconButton
            ref={ref}
            onClick={onToggle}
            icon={
                <svg width={16} height={16} viewBox='0 0 22 20'>
                    <Path
                        variants={{
                            closed: { d: 'M 2 2.5 L 20 2.5' },
                            open: { d: 'M 3 16.5 L 17 2.5' },
                        }}
                        stroke={useColorModeValue('white', 'var(--chakra-colors-gray-800)')}
                    />
                    <Path
                        d='M 2 9.423 L 20 9.423'
                        variants={{
                            closed: { opacity: 1 },
                            open: { opacity: 0 },
                        }}
                        transition={{ duration: 0.1 }}
                        stroke={useColorModeValue('white', 'var(--chakra-colors-gray-800)')}
                    />
                    <Path
                        variants={{
                            closed: { d: 'M 2 16.346 L 20 16.346' },
                            open: { d: 'M 3 2.5 L 17 16.346' },
                        }}
                        stroke={useColorModeValue('white', 'var(--chakra-colors-gray-800)')}
                    />
                </svg>
            }
            {...rest}
        />
    </motion.div>
));

const Path = (props: any) => <motion.path fill='transparent' strokeWidth={3} strokeLinecap={'round'} {...props} />;
